// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".graphiql-container {\n  overflow: auto;\n}\n\n.graphiql-container .historyPaneWrap {\n  overflow: auto !important;\n  max-height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
